import React from 'react';

import styled from 'styled-components';
import { Button } from 'styles/admin';
import { ButtonSpacer } from 'styles/auth';
import { StyledBox } from 'styles/common';

const EmployeeSidePanelFooter = ({ loading, mode, onSubmit = () => {}, onCancel = () => {} }) => (
  <Box padding="1rem" marginTop="auto" flexcontainer alignitems="center" justifycontent="flex-end">
    <StyledBox flexcontainer justifycontent="center" style={{ minHeight: '2.5rem' }}>
      <Button blueOutline size="large" onClick={onCancel} style={{ width: '10rem', padding: '0.3rem 1.5rem' }}>
        Cancel
      </Button>
      <ButtonSpacer />

      <Button size="large" blue rightGutter={3} onClick={onSubmit} style={{ width: '10rem' }} disabled={loading}>
        {mode === 'add' ? 'Add' : 'Update'}
      </Button>
    </StyledBox>
  </Box>
);

const Box = styled(StyledBox)`
  background: white;
`;

export default EmployeeSidePanelFooter;
